<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import AnalyticsTabs from '@/components/page-user-analytics/AnalyticsTabs.vue';
import GeneralAnalyticsList from '@/components/page-user-analytics/GeneralAnalyticsList.vue';
import SearchQueryAnalyticsList from '@/components/page-user-analytics/SearchQueryAnalyticsList.vue';
import UserEdit from '@/components/page-user-edit/user-edit/UserEdit.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    ANALYTICS_TABS: constants.ANALYTICS_TABS,
    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        AnalyticsTabs,
        GeneralAnalyticsList,
        SearchQueryAnalyticsList,
        UserEdit,
    },
    data() {
        return {
            activeTab: constants.ANALYTICS_TABS.GENERAL,
        };
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        await this.loadTabData(this.activeTab);

        // Load roles for UserEdit role dropdown and permissions display
        const promiseList = await calculatePromise([
            { dispatch: 'CHECK_ROLES_AXIOS', commit: 'ROLES', isArray: false },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);

        this.handleUserIdFromRoute();
    },
    watch: {
        '$route.params.userId': {
            handler() {
                this.handleUserIdFromRoute();
            },
        },
        activeTab(newTab) {
            this.loadTabData(newTab);
        },
    },
    methods: {
        async loadTabData(tab) {
            this.$store.commit('IS_LOAD', true);

            if (tab === constants.ANALYTICS_TABS.GENERAL) {
                await Promise.all([
                    this.$store.dispatch('loadUserAnalytics'),
                    this.$store.dispatch('loadRefreshStatus'),
                ]);
            } else {
                await this.$store.dispatch('loadSearchQueryAnalytics');
            }

            this.$store.commit('IS_LOAD', false);
        },

        handleUserIdFromRoute() {
            const userId = this.$route.params.userId;

            if (!userId) {
                this.closeUserEdit();
                return;
            }

            this.fetchAndOpenUser(userId);
        },

        closeUserEdit() {
            this.$store.commit('IS_SHOW_USER_EDIT', false);
        },

        async fetchAndOpenUser(userId) {
            try {
                const { axiosRequest, METHOD } = await import(
                    '@/api/default.js'
                );

                // Fetch user from API with filters matching user ID
                const params = {
                    limit: 100,
                    offset: 0,
                    sort: 'id:asc',
                    id: parseInt(userId),
                };

                const response = await axiosRequest({
                    url: constants.URL.USER_GET,
                    method: METHOD.GET,
                    params,
                    requestName: 'GET USER BY ID',
                    isLoader: false,
                });

                if (response?.data && response.data.length > 0) {
                    const user = response.data[0];
                    this.$store.commit('IS_SHOW_USER_EDIT', true);
                    this.$store.commit('USER_EDIT_SET', user);
                    await this.$store.dispatch('CHECK_USER_EDIT');
                } else {
                    // User not found
                    console.error('User not found');
                    this.$router.push({
                        name: constants.ROUTER_NAME.USERANALYTICS,
                    });
                }
            } catch (error) {
                console.error('Failed to load user:', error);
                this.$router.push({
                    name: constants.ROUTER_NAME.USERANALYTICS,
                });
            }
        },
    },
};
</script>

<template>
    <!-- User Edit Overlay -->
    <UserEdit />

    <!-- Background View -->
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <AnalyticsTabs
                :activeTab="activeTab"
                @update:activeTab="activeTab = $event"
            />

            <GeneralAnalyticsList
                v-if="activeTab === $options.ANALYTICS_TABS.GENERAL"
            />
            <SearchQueryAnalyticsList
                v-else-if="
                    activeTab === $options.ANALYTICS_TABS.SEARCH_QUERIES
                "
            />
        </RightContainer>
    </MainContainer>
</template>
